import { useT } from "@/lib/i18n";
import { fmtLap } from "@/lib/laps";

const th = "px-3 py-2.5 text-left whitespace-nowrap";
const td = "px-3 py-1.5 whitespace-nowrap";

const PickBtn = ({ active, color, onClick, testid, label }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className={`w-7 h-7 rounded-sm border font-mono text-xs font-bold transition-colors duration-150 ${active ? `${color} text-white border-transparent` : "border-[#282D3D] text-slate-500 hover:text-white"}`}>
    {label}
  </button>
);

export const TelemetryLapTable = ({ tel, best, a, b, c, setA, setB, setC, num }) => {
  const { t } = useT();
  const spd = tel.channels.find((c) => /speed/i.test(c));
  const rpm = tel.channels.find((c) => /rpm/i.test(c));
  return (
    <div data-testid="telemetry-lap-table" className="bg-[#12141C] border border-[#282D3D] rounded-sm overflow-x-auto max-h-[340px] overflow-y-auto">
      <table className="w-full font-mono text-xs sm:text-sm">
        <thead className="text-[10px] uppercase tracking-wider text-slate-500 bg-[#090A0F] sticky top-0">
          <tr>
            <th className={th}>A / B / C</th><th className={th}>{t("lap_col")}</th><th className={th}>{t("time_col")}</th><th className={th}>{t("gap_best")}</th>
            {spd && <th className={th}>V max</th>}{spd && <th className={th}>V min</th>}{rpm && <th className={th}>RPM max</th>}
          </tr>
        </thead>
        <tbody>
          {tel.laps.filter((l) => l.full).map((l) => {
            const isBest = best && l.lap === best.lap;
            return (
              <tr key={l.lap} data-testid={`telemetry-lap-${l.lap}`} className={`border-t border-[#282D3D]/60 ${isBest ? "bg-[#10B981]/10" : ""}`}>
                <td className={`${td} flex gap-1`}>
                  <PickBtn testid={`telemetry-pick-a-${l.lap}`} label="A" color="bg-[#007AFF]" active={a === l.lap} onClick={() => setA(l.lap)} />
                  <PickBtn testid={`telemetry-pick-b-${l.lap}`} label="B" color="bg-[#FF3B30]" active={b === l.lap} onClick={() => setB(b === l.lap ? null : l.lap)} />
                  <PickBtn testid={`telemetry-pick-c-${l.lap}`} label="C" color="bg-[#22D3EE]" active={c === l.lap} onClick={() => setC(c === l.lap ? null : l.lap)} />
                </td>
                <td className={td}>{num[l.lap]}</td>
                <td className={`${td} font-bold ${isBest ? "text-[#10B981]" : "text-white"}`}>{fmtLap(l.time, 3)}</td>
                <td className={`${td} text-slate-400`}>{best && l.lap !== best.lap ? `+${(l.time - best.time).toFixed(3)}` : ""}</td>
                {spd && <td className={td}>{l.max[spd]}</td>}
                {spd && <td className={td}>{l.min[spd]}</td>}
                {rpm && <td className={td}>{l.max[rpm]}</td>}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
